import { algorithmTypes } from '../../config/AlgorithmTypes.js';
import { CONFIG } from '../../config/Config';
import { AlgorithmVersion } from '../../types/index.js';
import { getModelsForAlgorithmVersion, getAlgorithmVersions, createScoringForAlgorithm } from '../api/algorithm-api';

export const isAlgorithmEnabled = (algorithmId: number) => {
  const algorithmType = CONFIG.algorithms.find(algorithmType => algorithmType.id === algorithmId);
  return algorithmType ? algorithmType.enabled : false;
};

export const isAlgorithmDisabledForCustomization = (algorithmId: number) => {
  const algorithmType = CONFIG.algorithms.find(algorithmType => algorithmType.id === algorithmId);
  return algorithmType ? (algorithmType.enabled ? algorithmType.hide_customization : true) : false;
};

export const isAlgorithmDisabledForFlow = (algorithmId: number) => {
  const algorithmType = CONFIG.algorithms.find(algorithmType => algorithmType.id === algorithmId);
  return algorithmType ? (algorithmType.enabled ? algorithmType.hide_flow : true) : false;
};

export const getAlgorithmValue = (algorithmName: string) => {
  const algorithmType = algorithmTypes.find(algorithmType => algorithmType.name === algorithmName);
  return (algorithmType && algorithmType.value) || '';
};

export const getAlgorithmOverviewDescription = (algorithmName: string) => {
  const algorithmType = algorithmTypes.find(algorithmType => algorithmType.name === algorithmName);
  return (algorithmType && algorithmType.overviewDescription) || '';
};

export const getAlgorithmFlowName = (algorithmName: string) => {
  const algorithmType = algorithmTypes.find(algorithmType => algorithmType.name === algorithmName);
  return algorithmType && algorithmType.flowValue;
};

export const getAlgorithmDemoAction = (algorithmName: string) => {
  const algorithmType = algorithmTypes.find(algorithmType => algorithmType.name === algorithmName);
  return algorithmType && algorithmType.demoAction;
};

export const getAlgorithmIcon = (algorithmName: string) => {
  const algorithmType = algorithmTypes.find(algorithmType => algorithmType.name === algorithmName);
  if (!algorithmType) return null;
  return algorithmType.icon;
};

export const deductLatestAlgorithmVersions = async (algorithmId: number) => {
  const versions = await getAlgorithmVersions(algorithmId);
  const visibleVersions: AlgorithmVersion[] = [];

  await Promise.all(
    versions.map(async version => {
      const modelsForVersion = await getModelsForAlgorithmVersion(version.id);
      const pretrainedModels = modelsForVersion.filter(model => !model.lastModelVersionId && model.hidden === false);
      const showVersion = pretrainedModels.length > 0;
      if (showVersion) {
        visibleVersions.push(version);
      }
    })
  );

  const sortedVersions = visibleVersions.sort((a, b) => (a.timeCreated < b.timeCreated ? 1 : -1));
  return sortedVersions;
};

export const calculateScoringForAlgorithm = async (
  algorithmId: number,
  algorithmVersionVersion: string,
  preproduction: boolean
) => {
  await createScoringForAlgorithm(algorithmId, algorithmVersionVersion, preproduction);
};
